import React from "react";
import Links from "./helper/links";

const About = () => {
  return (
    <div className="padding text-text1 bg-bg1">
      <div className=" text-4xl lg:text-6xl mb-5">About</div>
      <div className="font-advent tracking-widest lg:text-4xl lg:w-2/3 mb-10">
        Exploring contemporary design practices with a focus in typographical solutions and intricate web development. Connecting good design with
        modern technology.Enjoy building web apps using React and TailwidCss.
      </div>
      <div className="text-3xl lg:text-5xl my-9  ">Stack</div>
      <div className="font-advent lg:text-xl font-bold mb-10 ">
        HTML5 - CSS3 - JAVASCRIPT - SASS - REACTJS - GRAPHQL - GATSBY - TAILWINDCSS - BOOTSTRAP
      </div>
      <div className="text-3xl lg:text-5xl  my-8 ">Contact</div>
      <div className="flex relative lg:text-xl space-x-4 font-advent  tracking-widest underline">
        <Links />
      </div>
    </div>
  );
};

export default About;
